<template>
  <div id="main-wrap">
    <div id="main">
      <div
        :style="{
          height: `100vh`,
        }"
      >
        <div
          :style="{
            height: bodyHeight || '1080px',
            'transformOrigin':'left top',
            'transform':`scale(${scalseNum})`,
            '-webkit-transform':`scale(${scalseNum})`,
            '-moz-transform':`scale(${scalseNum})`,
            '-o-transform':`scale(${scalseNum})`,
            '-ms-transform':`scale(${scalseNum})`,
          }"
        >
          <div id="BSC" class="BSC">
            <h2>个人积分卡</h2>
            <div class="content-wrap-t">
              <div class="yuangong-lists">
                <el-autocomplete
                  class="per-wrap"
                  popper-class="my-autocomplete"
                  v-model="state"
                  :fetch-suggestions="querySearch"
                  placeholder="请输入内容"
                  @select="handleSelect"
                  size="mini"
                >
                  <i
                    class="el-icon-search el-input__icon"
                    slot="suffix"
                    @click="handleIconClick"
                  >
                  </i>
                  <template slot-scope="{ item }">
                    <div class="name" @click="getOwerInfo(item)">{{ item.empName }}</div>
                    <!-- <span class="addr">{{ item.empId }}</span> -->
                  </template>
                </el-autocomplete>
                <div class="y-item" v-for="item in owerLists" @click="getOwerInfo(item)">{{ item.empName }}</div>
              </div>
              <div
                style="
                border: 1px solid;
                padding: 0 10px 10px 10px;
                border-radius: 10px;
                width: 1762px;
                "
              >
                <div class="user-name">
                  {{ owerName }}
                </div>
                <div class="box-wrap" style="margin-bottom:10px">
                  <div class="title">公司指标</div>
                  <div class="box-content">
                    <div class="item-r huan-type">
                      <div class="item-title">营收（年/季/月）</div>
                      <div class="chart-wrap">
                        <DomLegend :lists="CompanyIndicators.revenue" :dw="'%'"></DomLegend>
                        <DomeEchartWrap ref="c-revenue" id="c-revenue" class="canvas-wrap"></DomeEchartWrap>
                      </div>
                    </div>
                    <div class="item-r huan-type">
                      <div class="item-title">净利润（年/季/月）</div>
                      <div class="chart-wrap">
                        <DomLegend :lists="CompanyIndicators.netProfit" :dw="'%'"></DomLegend>
                        <DomeEchartWrap ref="c-netProfit" id="c-netProfit" class="canvas-wrap"></DomeEchartWrap>
                      </div>
                    </div>
                    <div class="item-r huan-type">
                      <div class="item-title">产品线指标</div>
                      <div class="chart-wrap">
                        <DomLegend :lists="CompanyIndicators.product"></DomLegend>
                        <DomeEchartWrap ref="c-product" id="c-product" class="canvas-wrap"></DomeEchartWrap>
                      </div>
                    </div>
                    <div class="item-r huan-type">
                      <div class="item-title">效率指标</div>
                      <div class="chart-wrap">
                        <RangkProgress :list="PopularCities"></RangkProgress>
                      </div>
                    </div>
                    <div class="item-r huan-type item-r-left">
                      <div class="item-title">服务指标</div>
                      <div class="chart-wrap card-wrap">
                        <BscSmallCard class="card-item" v-for="item in cServiceIndicatorsLists" :item="item"></BscSmallCard>
                        <!-- <BscSmallCard class="card-item"></BscSmallCard>
                        <BscSmallCard class="card-item"></BscSmallCard>
                        <BscSmallCard class="card-item"></BscSmallCard> -->
                      </div>
                    </div>
                    <div class="item-r huan-type">
                      <div class="item-title">体验指标</div>
                      <div class="chart-wrap">
                        <DomLegend :lists="CompanyIndicators.experienceIndicators"></DomLegend>
                        <DomeEchartWrap ref="c-experienceIndicators" id="c-experienceIndicators" class="canvas-wrap"></DomeEchartWrap>
                      </div>
                    </div>
                    <div class="item-r huan-type">
                      <div class="item-title">量指标</div>
                      <div class="chart-wrap">
                        <DomLegend :lists="CompanyIndicators.quantitative" dw="万"></DomLegend>
                        <DomeEchartWrap ref="c-quantitative" id="c-quantitative" class="canvas-wrap"></DomeEchartWrap>
                      </div>
                    </div>
                    <div class="item-r huan-type">
                      <div class="item-title">率指标</div>
                      <div class="chart-wrap">
                        <DomLegend dw="%" :lists="CompanyIndicators.rateIndex"></DomLegend>
                        <DomeEchartWrap ref="c-rateIndex" id="c-rateIndex" class="canvas-wrap"></DomeEchartWrap>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="box-wrap">
                  <div class="title">组织指标</div>
                  <div class="box-content">
                    <div class="item-r huan-type">
                      <div class="item-title">营收（年/季/月）</div>
                      <div class="chart-wrap">
                        <DomLegend dw="%" :lists="OrganizationalIndicators.revenue"></DomLegend>
                        <DomeEchartWrap ref="o-revenue" id="o-revenue" class="canvas-wrap"></DomeEchartWrap>
                      </div>
                    </div>
                    <div class="item-r huan-type">
                      <div class="item-title">净利润（年/季/月）</div>
                      <div class="chart-wrap">
                        <DomLegend dw="%" :lists="OrganizationalIndicators.netProfit"></DomLegend>
                        <DomeEchartWrap ref="o-netProfit" id="o-netProfit" class="canvas-wrap"></DomeEchartWrap>
                      </div>
                    </div>
                    <div class="item-r huan-type">
                      <div class="item-title">产品线指标</div>
                      <div class="chart-wrap">
                        <DomLegend :lists="OrganizationalIndicators.product"></DomLegend>
                        <DomeEchartWrap ref="o-product" id="o-product" class="canvas-wrap"></DomeEchartWrap>
                      </div>
                    </div>
                    <div class="item-r huan-type">
                      <div class="item-title">效率指标</div>
                      <div class="chart-wrap">
                        <RangkProgress :list="PopularCities"></RangkProgress>
                      </div>
                    </div>
                    <div class="item-r huan-type item-r-left">
                      <div class="item-title">服务指标</div>
                      <div class="chart-wrap card-wrap">
                        <BscSmallCard class="card-item" v-for="item in cServiceIndicatorsLists" :item="item"></BscSmallCard>
                      </div>
                    </div>
                    <div class="item-r huan-type">
                      <div class="item-title">体验指标</div>
                      <div class="chart-wrap">
                        <DomLegend :lists="OrganizationalIndicators.experienceIndicators"></DomLegend>
                        <DomeEchartWrap ref="o-experienceIndicators" id="o-experienceIndicators" class="canvas-wrap"></DomeEchartWrap>
                      </div>
                    </div>
                    <div class="item-r huan-type">
                      <div class="item-title">量指标</div>
                      <div class="chart-wrap">
                        <DomLegend :lists="OrganizationalIndicators.quantitative"></DomLegend>
                        <DomeEchartWrap ref="o-quantitative" id="o-quantitative" class="canvas-wrap"></DomeEchartWrap>
                      </div>
                    </div>
                    <div class="item-r huan-type">
                      <div class="item-title">率指标</div>
                      <div class="chart-wrap">
                        <DomLegend dw="%" :lists="OrganizationalIndicators.rateIndex"></DomLegend>
                        <DomeEchartWrap ref="o-rateIndex" id="o-rateIndex" class="canvas-wrap"></DomeEchartWrap>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="box-wrap box-wrap-gw">
                  <div class="title">岗位职责</div>
                  <div class="gw-content">
                    <div class="box-content">
                      <div class="item-s" v-for="item in gangweiLists">
                        <div class="item-label">{{ item.label }}：</div>
                        <div class="item-start">
                          <el-rate
                            v-model="item.rate"
                            :colors="colors"
                            disabled
                          >
                          </el-rate>
                        </div>
                      </div>
                    </div>
                    <!-- <div class="box-tip-info">
                      <div class="tip-title">评价规则</div>
                      <div class="tip-content">
                        "能打分的人可以选择分类，会弹出打分页，等级详情打分原因，打开自己页面的可以看到评分结果"
                      </div>
                    </div> -->
                    <div class="btn-applit-jf">
                      <el-button type="primary" @click="dialogFormVisible = true">申请加分</el-button>
                    </div>
                  </div>
                </div>
                <div class="box-wrap">
                  <div class="title">个人任务</div>
                  <div style="width:100%" id="progree-wrap">
                    <ProgressBar :lists="beginLists"></ProgressBar>
                    <ProgressBar :lists="endLists"></ProgressBar>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog title="评分" :visible.sync="dialogFormVisible" destroy-on-close>
      <applyExtraPointsVue :formvisible.sync="dialogFormVisible"></applyExtraPointsVue>
    </el-dialog>
  </div>
</template>

<script>
import DomeEchartWrap from '@/components/echarts/DomeEchartWrap'
import DomLegend from './domLegend.vue'
import RangkProgress from './rangkProgress.vue'
import { UserRetentionPaymentIndexEchartOp, CProductEchart, CRevenueEchartOp } from './js/index.js'
import scalseNum from '@/mixins/scalseNum.js'
import BscSmallCard from './domSmallCard.vue'
import ProgressBar from './progressBar.vue'
import applyExtraPointsVue from './applyExtraPoints.vue'
export default {
  name: 'BSC',
  mixins: [scalseNum],
  props: [],
  data () {
    return {
      UserPaymentDistributionLists: [],
      colors: ['#99A9BF', '#F7BA2A', '#FF9900'],
      gangweiLists: [
        // {
        //   label: '诚信正直',
        //   rate: 4
        // },
        // {
        //   label: '执行力',
        //   rate: 4
        // },
        // {
        //   label: '培养人才',
        //   rate: 4
        // },
        // {
        //   label: '思考能力',
        //   rate: 4
        // },
        // {
        //   label: '规划力',
        //   rate: 4
        // },
        // {
        //   label: '领导力',
        //   rate: 4
        // },
        // {
        //   label: '创新改进',
        //   rate: 4
        // },
        // {
        //   label: '目标管理',
        //   rate: 4
        // }
      ],
      restaurants: [],
      state: '',
      timeout: null,
      cServiceIndicatorsLists: [
        {
          name: '投诉量',
          val: 100,
          hb: 0.6,
          tb: 0.2
        },
        {
          name: '投诉率',
          val: 25,
          hb: 0.3,
          tb: 0.4
        },
        {
          name: '满意率',
          val: 89,
          hb: 0.4,
          tb: 0.15
        },
        {
          name: '平均解决时长',
          val: '8h',
          hb: 0.5,
          tb: 0.3
        }
      ],
      oServiceIndicatorsLists: [
        {
          name: '投诉量',
          val: 100,
          hb: 0.6,
          tb: 0.2
        },
        {
          name: '投诉率',
          val: 25,
          hb: 0.3,
          tb: 0.4
        },
        {
          name: '满意率',
          val: 89,
          hb: 0.4,
          tb: 0.15
        },
        {
          name: '平均解决时长',
          val: '8h',
          hb: 0.5,
          tb: 0.3
        }
      ],
      CompanyIndicators: {
        revenue: {},
        netProfit: {},
        product: {},
        experienceIndicators: {},
        quantitative: {},
        rateIndex: {}
      },
      OrganizationalIndicators: {
        revenue: {},
        netProfit: {},
        product: {},
        experienceIndicators: {},
        quantitative: {},
        rateIndex: {}
      },
      owerName: '', // 用户名
      owerLists: [], // 同部门同事
      beginLists: [
        {
          name: '业务自动化',
          time: '四月一号',
          week: 'W14'
        },
        {
          name: '业务自动化',
          time: '九月',
          week: 'W39'
        },
        {
          name: '业务自动化',
          time: '12月',
          week: 'W52',
          status: 'finish'
        }
      ],
      endLists: [
        {
          name: '酷开9',
          time: '一月',
          week: 'W1'
        },
        {
          name: '酷开9',
          time: '十一月',
          week: 'W47'
        },
        {
          name: '酷开9',
          time: '十二月',
          week: 'W52',
          status: 'finish'
        }
      ],
      dialogFormVisible: false,
      PopularCities: [
        { 'name': '人均劳效', 'count': 3, 'rate': '100', dw: '万' },
        { 'name': '费用率', 'count': 89.40, 'rate': '89.40', dw: '%' },
        { 'name': '研发费用率', 'count': 83.97, 'rate': '83.97', dw: '%' },
        { 'name': '存货周转', 'count': 6.21, 'rate': '6.21', dw: '%' },
        { 'name': '应收周转', 'count': 4.19, 'rate': '4.19', dw: '%' },
        { 'name': 'ROE', 'count': 0.79, 'rate': '0.79', dw: '%' }
      ]
    }
  },
  computed: {
    bodyHeight () {
      return this.$route.meta.bodyHeight || null
    }
  },
  created () {},
  mounted () {
    this.initCreateBarRate()
    // this.restaurants = this.loadAll()
    this.getUserLists(this.$route.query.userId)
    this.getUserData(this.$route.query.userId)
    document.body.style.backgroundColor = '#fff'
  },
  watch: {},
  methods: {
    testPay (val) {
      if (!val) {
        return
      }
      let name = []
      let data = []
      let max = 0
      val.forEach((item) => {
        name.unshift(item.productType)
        data.unshift(item.total)
        this.UserPaymentDistributionLists.push({
          name: item.productType,
          rate: 0
        })
      })
      max = Math.max(...data) * 1.2
      console.log(this.$refs['test'])
      for (let index = 1; index < 8; index++) {
        if ([4, 5].includes(index)) { continue }
        this.$refs[`test${index}`].setEchartOption(
          UserRetentionPaymentIndexEchartOp({
            v: this,
            data: {
              name,
              data,
              max
            }
          })
        )
      }
    },
    initCreateBarRate () {
      let revenue = {
        name: ['月达成率', '季达成率', '年达成率'],
        nameLabel: ['年', '季', '月'],
        data: [83.41, 79.64, 89.64],
        max: 100,
        rate: {
          hb: [0.45, -0.48, -0.47],
          tb: [0.67, -0.59, 0.47]
        }
      }
      this.$refs['c-revenue'].setEchartOption(CRevenueEchartOp({ v: this,
        data: revenue
      }))
      this.CompanyIndicators.revenue = revenue

      //
      let netProfit = {
        name: ['月达成率', '季达成率', '年达成率'],
        nameLabel: ['年', '季', '月'],
        data: [46.58, 49.58, 93.93],
        max: 100,
        rate: {
          hb: [0.45, -0.48, -0.47],
          tb: [0.67, -0.59, 0.47]
        }
      }
      this.$refs['c-netProfit'].setEchartOption(CRevenueEchartOp({ v: this,
        data: netProfit
      }))
      this.CompanyIndicators.netProfit = netProfit

      //
      let product = {
        name: ['会员收入占比', '流量收入占比', '软件收入占比', '硬件收入占比'],
        data: [12.15, 6.5, 0.1, 1.43],
        rate: {
          hb: [-0.48, 25.76, 351.02, -10.26],
          tb: [18.97, -22.03, 0, -45.49]
        }
      }
      this.$refs['c-product'].setEchartOption(CProductEchart({ v: this,
        data: product
      }))
      this.CompanyIndicators.product = product
      // 体验指标
      let experienceIndicators = {
        name: ['体验旅程', '卡设计', '按顺序排列', '硬件收入'],
        data: [14038, 4111, 2438, 2222],
        max: 20000,
        rate: {
          hb: [0.45, -0.48, -0.47, 0.2],
          tb: [0.67, -0.59, 0.47, 0.1]
        }
      }
      this.$refs['c-experienceIndicators'].setEchartOption(CRevenueEchartOp({ v: this,
        data: experienceIndicators
      }))
      this.CompanyIndicators.experienceIndicators = experienceIndicators
      // 量指标
      // let quantitative = {
      //   name: ['月活终端数', '日活终端数', '会员数', '新增会员数'],
      //   data: [1757, 4111, 14038, 2222],
      //   max: 20000,
      //   rate: {
      //     hb: [0.45, -0.48, -0.47, 0.2],
      //     tb: [0.67, -0.59, 0.47, 0.1]
      //   }
      // }
      // this.$refs['c-quantitative'].setEchartOption(CRevenueEchartOp({ v: this,
      //   data: quantitative
      // }))
      // this.CompanyIndicators.quantitative = quantitative
      // 率指标
      // let rateIndex = {
      //   name: ['月均活跃率', '日均活跃率', '会员渗透率', '日均会员转化率'],
      //   data: [17, 14, 38, 22],
      //   max: 100,
      //   rate: {
      //     hb: [0.45, -0.48, -0.47, 0.2],
      //     tb: [0.67, -0.59, 0.47, 0.1]
      //   }
      // }
      // this.$refs['c-rateIndex'].setEchartOption(CRevenueEchartOp({ v: this,
      //   data: rateIndex
      // }))
      // this.CompanyIndicators.rateIndex = rateIndex
      /// //------------------------组织
      let orevenue = {
        name: ['月达成率', '季达成率', '年达成率'],
        nameLabel: ['年', '季', '月'],
        data: [83.41, 79.64, 89.64],
        max: 100,
        rate: {
          hb: [0.45, -0.48, -0.47],
          tb: [0.67, -0.59, 0.47]
        }
      }
      this.$refs['o-revenue'].setEchartOption(CRevenueEchartOp({ v: this,
        data: orevenue
      }))
      this.OrganizationalIndicators.revenue = orevenue
      //
      let onetProfit = {
        name: ['月达成率', '季达成率', '年达成率'],
        nameLabel: ['年', '季', '月'],
        data: [46.58, 49.58, 93.93],
        max: 100,
        rate: {
          hb: [0.45, -0.48, -0.47],
          tb: [0.67, -0.59, 0.47]
        }
      }
      this.$refs['o-netProfit'].setEchartOption(CRevenueEchartOp({ v: this,
        data: onetProfit
      }))
      this.OrganizationalIndicators.netProfit = onetProfit

      //
      let oproduct = {
        name: ['影视会员', '少儿会员'],
        data: [1757, 4111],
        max: 5000,
        rate: {
          hb: [0.45, -0.48],
          tb: [0.67, -0.59]
        }
      }
      this.$refs['o-product'].setEchartOption(CRevenueEchartOp({ v: this,
        data: oproduct
      }))
      this.OrganizationalIndicators.product = oproduct
      // 体验指标
      let oexperienceIndicators = {
        name: ['体验旅程', '卡设计', '按顺序排列', '硬件收入'],
        data: [14038, 4111, 2438, 2222],
        max: 20000,
        rate: {
          hb: [0.45, -0.48, -0.47, 0.2],
          tb: [0.67, -0.59, 0.47, 0.1]
        }
      }
      this.$refs['o-experienceIndicators'].setEchartOption(CRevenueEchartOp({ v: this,
        data: oexperienceIndicators
      }))
      this.OrganizationalIndicators.experienceIndicators = oexperienceIndicators
      // 量指标
      // this.setQuantitative()
      // // 率指标
      // let orateIndex = {
      //   name: ['月均活跃率', '日均活跃率', '会员渗透率', '日均会员转化率'],
      //   data: [17, 14, 38, 22],
      //   max: 100,
      //   rate: {
      //     hb: [0.45, -0.48, -0.47, 0.2],
      //     tb: [0.67, -0.59, 0.47, 0.1]
      //   }
      // }
      // this.$refs['o-rateIndex'].setEchartOption(CRevenueEchartOp({ v: this,
      //   data: orateIndex
      // }))
      // this.OrganizationalIndicators.rateIndex = orateIndex
    },
    querySearch (queryString, cb) {
      // 获取同部门的同事
      this.getUserNameLists(queryString).then(res => {
      // var restaurants = res
      // var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants
        cb(res)
      })
      // 调用 callback 返回建议列表的数据
    },
    createFilter (queryString) {
      return (restaurant) => {
        return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0)
      }
    },
    // 公司指标---量指标
    setCQuantitative (amountMap, amountVO) {
      let mapNameKey = {
        '会员数': 'yxMemberIndicator',
        '日活终端数': 'dayActiveIndicator',
        '月活终端数': 'monthActiveIndicator',
        '新增会员数': 'newMemberIndicator'
      }
      let a = this.justifyData(amountMap, amountVO, mapNameKey)
      console.log(a)
      a.max = Math.max(...a.data) * 1.3
      // let oquantitative = {
      //   name: ['月活终端数', '日活终端数', '会员数', '新增会员数'],
      //   data: [1757, 4111, 14038, 2222],
      //   count: [1757, 4111, 14038, 2222],
      //   max: 20000,
      //   rate: {
      //     hb: [0.45, -0.48, -0.47, 0.2],
      //     tb: [0.67, -0.59, 0.47, 0.1]
      //   }
      // }
      let oquantitative = a ?? {}
      this.$refs['c-quantitative'].setEchartOption(CRevenueEchartOp({ v: this,
        data: oquantitative
      }))
      this.CompanyIndicators.quantitative = oquantitative
    },
    // 公司指标---率指标
    setCRateIndex (rateMap, rateVO) {
      let mapNameKey = {
        '会员渗透率': 'memberRateIndicator',
        '日均会员转化率': 'avgMemberRateIndicator',
        '日均活跃率': 'dayAvgActiveIndicator',
        '月均活跃率': 'monthAcitveRateIndicator'
      }
      let a = this.justifyData(rateMap, rateVO, mapNameKey)
      a.max = Math.max(...a.data) * 1.3
      let rateIndex = a
      // // 率指标
      // let rateIndex = {
      //   name: ['月均活跃率', '日均活跃率', '会员渗透率', '日均会员转化率'],
      //   data: [17, 14, 38, 22],
      //   max: 100,
      //   rate: {
      //     hb: [0.45, -0.48, -0.47, 0.2],
      //     tb: [0.67, -0.59, 0.47, 0.1]
      //   }
      // }
      this.$refs['c-rateIndex'].setEchartOption(CRevenueEchartOp({ v: this,
        data: rateIndex
      }))
      this.CompanyIndicators.rateIndex = rateIndex
    },
    handleSelect (item) {
      console.log(item)
      if (!item?.empName) { return }
      this.owerName = item.empName
      // this.getUserLists(item.empId)
    },
    // 组织指标---量指标
    setOQuantitative (amountMap, amountVO) {
      let mapNameKey = {
        '会员数': 'yxMemberIndicator',
        '日活终端数': 'dayActiveIndicator',
        '月活终端数': 'monthActiveIndicator',
        '新增会员数': 'newMemberIndicator'
      }
      let a = this.justifyData(amountMap, amountVO, mapNameKey)
      console.log(a)
      a.max = Math.max(...a.data) * 1.3
      // let oquantitative = {
      //   name: ['月活终端数', '日活终端数', '会员数', '新增会员数'],
      //   data: [1757, 4111, 14038, 2222],
      //   count: [1757, 4111, 14038, 2222],
      //   max: 20000,
      //   rate: {
      //     hb: [0.45, -0.48, -0.47, 0.2],
      //     tb: [0.67, -0.59, 0.47, 0.1]
      //   }
      // }
      let oquantitative = a ?? {}
      this.$refs['o-quantitative'].setEchartOption(CRevenueEchartOp({ v: this,
        data: oquantitative
      }))
      this.OrganizationalIndicators.quantitative = oquantitative
    },
    setORateIndex (rateMap, rateVO) {
      let mapNameKey = {
        '会员渗透率': 'memberRateIndicator',
        '日均会员转化率': 'avgMemberRateIndicator',
        '日均活跃率': 'dayAvgActiveIndicator',
        '月均活跃率': 'monthAcitveRateIndicator'
      }
      let a = this.justifyData(rateMap, rateVO, mapNameKey)
      a.max = Math.max(...a.data) * 1.3
      let rateIndex = a
      // // 率指标
      // let rateIndex = {
      //   name: ['月均活跃率', '日均活跃率', '会员渗透率', '日均会员转化率'],
      //   data: [17, 14, 38, 22],
      //   max: 100,
      //   rate: {
      //     hb: [0.45, -0.48, -0.47, 0.2],
      //     tb: [0.67, -0.59, 0.47, 0.1]
      //   }
      // }
      this.$refs['o-rateIndex'].setEchartOption(CRevenueEchartOp({ v: this,
        data: rateIndex
      }))
      this.OrganizationalIndicators.rateIndex = rateIndex
    },
    // 设置岗位职责数据
    setDutyMapList (data) {
      // let dataEnteries = Object.entries(data)
      this.gangweiLists = data.reduce((a, b) => {
        let [[name = '', value = 0]] = Object.entries(b)
        a.push({
          label: name,
          rate: value / 20
        })
        return a
      }, [])
    },
    handleIconClick (ev) {
      console.log(ev)
      if (!ev?.empName) { return }
      this.owerName = ev.empName
      this.getUserLists(ev.userId)
      this.getUserData(ev.userId)
    },
    getUserLists (id) {
      if (!id) { return }
      this.$service.fetch({
        url: '/api/bsc/org/index',
        params: {
          userId: id
        }
      }).then(res => {
        this.owerName = res['我的积分'].empName
        this.owerLists = res['我的同级']
      })
    },
    getOwerInfo (item) {
      this.getUserLists(item.userId)
      this.getUserData(item.userId)
    },
    getUserNameLists (name) {
      return this.$service.fetch({
        url: '/api/bsc/getUserId',
        params: {
          userName: name
        }
      })
    },
    getUserData (id) {
      this.$service.fetch({
        url: '/api/bsc/index',
        params: {
          userId: id
        }
      }).then(res => {
        console.log(res)
        let { companyVO, dutyMapList } = res ?? {}
        let { amountChartList, amountVO, rateChartList, rateVO } = companyVO ?? {}
        // 公司
        this.setCQuantitative(amountChartList, amountVO)// 量指标
        this.setCRateIndex(rateChartList, rateVO)// 率指标
        // 组织
        this.setOQuantitative(amountChartList, amountVO)// 量指标
        this.setORateIndex(rateChartList, rateVO)// 率指标

        // 岗位职责
        this.setDutyMapList(dutyMapList)
      })
    },
    justifyData (map = [], amo, mapKey = {}) {
      let enteData = Object.entries(map)
      return map.reduce((a, b) => {
        let name = b.name
        a.name.push(name)
        a.data.push(b.value)
        let key = mapKey[name] ?? ''
        a.count.push(amo[key]?.periodRate ?? 0)
        a.rate.hb.push(amo[key]?.mRatio ?? 0)
        a.rate.tb.push(amo[key]?.yRatio ?? 0)
        return a
      }, {
        name: [],
        data: [],
        count: [],
        max: 100000,
        rate: {
          hb: [],
          tb: []
        }
      })
    }
  },
  beforeRouteLeave () {
    document.body.style.backgroundColor = '#0b0b1e'
  },
  components: {
    DomeEchartWrap,
    DomLegend,
    RangkProgress,
    BscSmallCard,
    ProgressBar,
    applyExtraPointsVue
  }
}
</script>

<style scoped lang="stylus">
#main-wrap
  width 100vw
  height 100vh
  overflow auto
#main
  transform-origin: left top;
#BSC
  // padding 0px 20px 20px 20px
  background-color: #fff !important
  width 1920px
  box-sizing: border-box;
  *
    box-sizing: border-box;
  h2
    color #000
    height 50px
    line-height: 50px
    font-weight bolder
    font-size: 36px
    margin: 20px 0
.box-wrap
  border: 1px solid #363636;
  border-radius: 10px;
  padding: 20px
  background-color: #fff
  display: flex
  &+.box-wrap
    margin-bottom: 10px
  .title
    color: #000;
    font-size: 28px;
    font-weight: 600;
    text-align: center;
    display flex
    align-items: center
    margin-right: 20px
    width 28px
  .box-content
    display: flex;
    flex-wrap: wrap;
    width: 1660px

  .item-r
    display: flex;
    flex-direction: column
    width 398px
    .chart-wrap
      display flex
      flex-grow: 1
      margin-bottom: 10px
      justify-content: space-between
      .canvas-wrap
        width 228px
        height 180px
    .chart-wrap.card-wrap
      flex-wrap: wrap
      justify-content: space-between
      align-content: center
      .card-item
        width 193.5px
        height 85.5px
        padding 10px
      .card-item:nth-of-type(n+3)
        margin-top 10px
    .item-title
      color: #000
      text-align center
      margin: 0 0 10px 0
      font-size: 22px
      font-weight: bolder
    &:nth-of-type(n+5)
      margin-top 20px
  .item-r+.item-r
    margin-left 19px
  .item-r.item-r-left
    margin-left 0
  .item-s
    display: flex;
    align-items: center;
    .item-label
      color #000
      white-space nowrap
      width 95px
    .el-rate
      display: flex
      align-items: center;
.box-wrap-gw
  .title
    width 50px
  .box-content
    display: flex;
    flex-wrap: wrap
    height initial
    .item-s
      width 33%
      margin-bottom 30px
      &:nth-of-type(n+3)
        margin-top 10px
      >>>
        .el-rate__icon
          font-size 36px
  .box-tip-info
    color rgba(133,133,133,1)
    .tip-title
      margin 20px 0 20px 0
      font-size 22px
    .tip-content
      text-align: center
      color: rgba(0, 0, 0,.8)
  .gw-content
    padding-left: 20px
.content-wrap-t
  display: flex
  .yuangong-lists
    flex 0 0 148px
    border: 1px solid #000;
    border-radius: 10px;
    padding: 20px 10px;
    background-color: rgba(255,255,255,1)
    margin-right: 10px
    color: rgba(0,0,0,1)
    .y-item
      padding: 5px 10px
      &:hover
        color rgba(255,255,255,0.8)
        background-color rgba(233,233,233,.7)
        cursor pointer
    .y-item+.y-item
      margin-top: 10px

.user-name
  font-size: 25px
  font-weight: bolder
  color: #000
  margin: 15px 0 15px 15px

.btn-applit-jf
  text-align right
  margin-right 80px
.per-wrap
  margin-bottom: 15px
  .my-autocomplete {
  li {
    line-height: normal;
    padding: 7px;

    .name {
      text-overflow: ellipsis;
      overflow: hidden;
    }
    .addr {
      font-size: 12px;
      color: #b4b4b4;
    }

    .highlighted .addr {
      color: #ddd;
    }
  }
}

</style>

// @media screen and (max-width:720px)
//   .box-wrap
//     .item-r
//       width 50%
//       height: 300px;
//       .chart-wrap
//         flex-direction column
//   .box-wrap-gw
//     .box-content
//       .item-s
//         width 50%
